// extracted by mini-css-extract-plugin
export default {"footerInfo":"FooterInfo_footerInfo__kv5au","footerInfo_logoName":"FooterInfo_footerInfo_logoName__l3ADc","footerInfo_link":"FooterInfo_footerInfo_link__rEaxA"};